import { z } from 'zod';

import { Address } from '../Address';
import { OptionalPhoneNumber } from '../Phone';

export const EntityApi = z.object({
  id: z.string(),
  name: z.string(),
  address: Address.optional(),
  phone: OptionalPhoneNumber,
  email: z.string().optional(),
});
export type EntityApi = z.infer<typeof EntityApi>;
